module.exports = __webpack_public_path__ + "img/feature_buy_freespin_id.70fcdcd7.png";